import { render, staticRenderFns } from "./CountdownGame.vue?vue&type=template&id=80e5c104&"
import script from "./CountdownGame.vue?vue&type=script&lang=js&"
export * from "./CountdownGame.vue?vue&type=script&lang=js&"
import style0 from "./CountdownGame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports